<template>
  <div id="app">
    <Content />
  </div>
</template>

<script>
import Content from "./views/Content.vue";

export default {
  name: "App",
  components: {
    Content
  }
};
</script>

<style>
html {
  margin: 0;
  padding: 0;
  height: 100vh;
  box-sizing: border-box;
}
body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background-color: #f4f4f4;

  /* 兼容 iOS < 11.2 */
  padding-top: constant(safe-area-inset-top);
  padding-left: constant(safe-area-inset-left);
  padding-right: constant(safe-area-inset-right);
  padding-bottom: constant(safe-area-inset-bottom);

  /* 兼容 iOS >= 11.2 */
  padding-top: env(safe-area-inset-top);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
}

img {
  width: 100%;
  height: auto;
  vertical-align: top;
  content: normal !important;
}

ul,
li {
  list-style: none outside none;
  margin: 0;
  padding: 0;
}
.loading {
  text-align: center;
  width: 100%;
  padding-top: 100px;
}
</style>
